export default __webpack_public_path__ + "static/media/lampstyle-light-blue.c60966d9.svg";